import { Css } from "@homebound/beam";

// Defines common spacing for different components.
// This allows us to maintain consistency between similar components,
// while still giving the parent element the flexibility to position elements as fits the design.

// Used when displaying multiple sections for CRUD screens (Contract and Commitment View/Edit/Create pages )
const crudSectionSpacingTopInc = 5;
export const crudSectionSpacingTopCss = Css.mt(crudSectionSpacingTopInc).$;
